"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetingExtensibilityConfiguration = void 0;
var React = require("react");
var microsoftTeams = require("@microsoft/teams-js");
var MeetingExtensibilityConfiguration = /** @class */ (function (_super) {
    __extends(MeetingExtensibilityConfiguration, _super);
    function MeetingExtensibilityConfiguration(props) {
        return _super.call(this, props) || this;
    }
    MeetingExtensibilityConfiguration.prototype.componentDidMount = function () {
        microsoftTeams.initialize();
        microsoftTeams.settings.registerOnSaveHandler(function (saveEvent) {
            microsoftTeams.settings.setSettings({
                entityId: "Balcão Virtual",
                contentUrl: window.location.origin + "/meeting-extensibility",
                suggestedDisplayName: "Balcão Virtual",
            });
            saveEvent.notifySuccess();
        });
        microsoftTeams.settings.setValidityState(true);
    };
    MeetingExtensibilityConfiguration.prototype.render = function () {
        return (React.createElement(React.Fragment, null, "Favor clicar em salvar para come\u00E7ar."));
    };
    return MeetingExtensibilityConfiguration;
}(React.Component));
exports.MeetingExtensibilityConfiguration = MeetingExtensibilityConfiguration;
//# sourceMappingURL=config.js.map